export default "__VITE_ASSET__DDedEz6B__"